import { ControlPanelScreen } from "@/screens/control-panel";

/** Thin wrapper — toda lógica fica em screens/control-panel */
export function ControlPanelPage() {
  return <ControlPanelScreen />;
}
